import GtagHelper from 'gtag-helper';

import { GTAG_ID } from 'consts';

const helper = new GtagHelper(GTAG_ID);

export default helper;
